import {Injectable, OnDestroy} from "@angular/core";
import {FilterMembers, FilterModel} from "../../framework/bi/filter/filter.model";
import {BIService} from "../../framework/bi/bi.service";
import {first, ReplaySubject, Subject, Subscription, timer} from "rxjs";
import {DashboardEntityModel} from "./dashboard-entity.model";
import {RestrictionsRequestData, RestrictionsRequestQueryData} from "../../framework/bi/restrictions-request.data";
import {MdxMemberUtil} from "../../framework/bi/mdx-member-util";
import {RestrictionsResponseData} from "../../framework/bi/restrictions-response.data";

export class DashboardFilter {
    constructor(public filterMembers: FilterMembers, public restrictions: RestrictionsResponseData) {
    }
}

/**
 * Resolve the restrictions for a dashboard and broadcast to charts
 */
@Injectable()
export class DashboardModel implements OnDestroy {

    private subscriptions: Subscription = new Subscription();

    private _dashboardFilter: DashboardFilter;

    dashboardFilter$: Subject<DashboardFilter> = new ReplaySubject<DashboardFilter>(1);

    refreshObservableSubscription: Subscription;

    constructor(private filterModel: FilterModel, private biService: BIService, private entityModel: DashboardEntityModel) {
        this.subscriptions.add(this.filterModel.filterMembersUpdated$.subscribe(filterMembers => {
            if (filterMembers) {
                const restrictionsRequestData: RestrictionsRequestData = new RestrictionsRequestData();
                restrictionsRequestData.cubeName = this.entityModel.data.cubeName;
                restrictionsRequestData.dashboardAttributes = filterMembers.members.map(value => MdxMemberUtil.getDimension(value));
                restrictionsRequestData.dateRangeRef = filterMembers.dateRange;
                restrictionsRequestData.queries = this.entityModel.data.charts.filter(chart => chart.selectedAttribute).map(chart => {
                    const restrictionsRequestQueryData: RestrictionsRequestQueryData = new RestrictionsRequestQueryData();
                    restrictionsRequestQueryData.name = chart.title;
                    restrictionsRequestQueryData.queryAttributes = chart.filterMembers.map(value => MdxMemberUtil.getDimension(value));
                    restrictionsRequestQueryData.queryAttributes.push(chart.selectedAttribute);
                    return restrictionsRequestQueryData;
                });

                if (this.refreshObservableSubscription) {
                    this.refreshObservableSubscription.unsubscribe();
                    this.refreshObservableSubscription = null;
                }

                this.biService.getRestrictions(restrictionsRequestData).then(response => {
                    this._dashboardFilter = new DashboardFilter(filterMembers, response);
                    this.dashboardFilter$.next(this.dashboardFilter);

                    if (response.refreshTime) {
                        this.refreshObservableSubscription = timer(response.refreshTime).pipe(first()).subscribe(() => {
                            this.filterModel.notifyFilterChange();
                        })
                    }
                });
            } else {
                this.dashboardFilter$.next(undefined);
            }
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();

        if (this.refreshObservableSubscription) {
            this.refreshObservableSubscription.unsubscribe();
        }
    }

    get dashboardFilter(): DashboardFilter {
        return this._dashboardFilter;
    }


}
